module.exports = __webpack_public_path__ + "img/surprising.98a2ff7b.jpg";